var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenderTransgender = function SvgIconGenderTransgender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m15.75 6.836 2.086-2.086h-1.711a1 1 0 1 1 0-2h4.125a1 1 0 0 1 .306.048 1 1 0 0 1 .694.972v4.105a1 1 0 1 1-2 0v-1.71L17.164 8.25l1.543 1.543a1 1 0 0 1-1.414 1.414L15.75 9.664l-1.143 1.144a7 7 0 1 1-1.414-1.414l1.143-1.144-1.543-1.543a1 1 0 0 1 1.414-1.414zM4 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconGenderTransgender;